import { PageTemplate, HeaderTemplate, ButtonLink } from "../styles";
import SizeChart from "../components/SizeChart";

const SizeGuide = () => {
  return (
    <PageTemplate className="no-header">
      <div className="content-page">
        <SizeChart />
      </div>
    </PageTemplate>
  );
};

export default SizeGuide;
